<script>
import { Router, Route } from 'svelte-routing';
import { onMount } from 'svelte';
import SignIn from './SignIn.svelte';

    export let API_URL;
    export let note = false;

    let view = note ? "read" : "input";
    export let content = "test";

//     export let content = `
//     Gaio Giulio Cesare (in latino: Gaius Iulius Caesar, Pronuncia restaurata o classica; AFI: [ˈɡäːjʊs ˈjuː.li.ʊs ˈkɐ̯ɛ̯.sä:r];[N 2][3] nelle epigrafi C·IVLIVS·C·F·CAESAR e DIVVS IVLIVS;[4] in greco antico: Γάϊος Ἰούλιος Καῖσαρ, Gáïos Iúlios Kaîsar; Roma, 13 luglio 101 a.C.[1] o 12 luglio 100 a.C.[2] – Roma, 15 marzo 44 a.C.) è stato un militare, politico, console, dittatore, pontefice massimo, oratore e scrittore romano, considerato uno dei personaggi più importanti e influenti della storia.[5]

// Ebbe un ruolo fondamentale nella transizione del sistema di governo dalla forma repubblicana a quella imperiale. Fu dittatore (dictator) di Roma alla fine del 49 a.C., nel 47 a.C., nel 46 a.C. con carica decennale e dal 44 a.C. come dittatore perpetuo, e per questo ritenuto da Svetonio il primo dei dodici Cesari, in seguito sinonimo di imperatore romano.[6] Con la conquista della Gallia estese il dominio della res publica romana fino all'oceano Atlantico e al Reno; portò gli eserciti romani a invadere per la prima volta la Britannia e la Germania e a combattere in Spagna, Grecia, Egitto, Ponto e Africa.

// Il primo triumvirato, l'accordo privato per la spartizione del potere con Gneo Pompeo Magno e Marco Licinio Crasso, segnò l'inizio della sua ascesa. Dopo la morte di Crasso (Carre, 53 a.C.), Cesare si scontrò con Pompeo e la fazione degli optimates per il controllo dello Stato. Nel 49 a.C., di ritorno dalla Gallia, guidò le sue legioni attraverso il Rubicone, pronunciando le celebri parole «Alea iacta est», e scatenò la guerra civile, con la quale divenne capo indiscusso di Roma: sconfisse Pompeo a Farsalo (48 a.C.) e successivamente gli altri optimates, tra cui Catone l'Uticense, in Africa e in Spagna.

// Con l'assunzione della dittatura a vita diede inizio a un processo di radicale riforma della società e del governo, riorganizzando e centralizzando la burocrazia repubblicana. Il suo operato provocò la reazione dei conservatori, finché un gruppo di senatori, capeggiati da Marco Giunio Bruto, Gaio Cassio Longino e Decimo Bruto, cospirò contro di lui, uccidendolo a pugnalate, alle idi di marzo del 44 a.C. (15 marzo 44). Nel 42 a.C., appena due anni dopo il suo assassinio, il Senato lo deificò ufficialmente, elevandolo a divinità. L'eredità riformatrice e storica di Cesare fu quindi raccolta da Ottaviano Augusto, suo pronipote e figlio adottivo.[7]

// Le campagne militari e le azioni politiche di Cesare sono da lui stesso dettagliatamente raccontate in terza persona nei Commentarii de bello Gallico e nei Commentarii de bello civili. Numerose notizie sulla sua vita sono presenti negli scritti di Appiano di Alessandria, Svetonio, Plutarco, Cassio Dione e Strabone. Altre informazioni possono essere rintracciate nelle opere di autori suoi contemporanei, come nelle lettere e nelle orazioni del suo rivale politico Cicerone, nelle poesie di Catullo e negli scritti storici di Sallustio.
//     `;

    let newParagraphs = [];

    let definition = [];
    let currentWord = "";
    let linkedWord = "";
    let linked = [];
    let language = "";

    const punctuation = {
        ".": true,
        ",": true,
        "!": true,
        ":": true,
        "?": true,
        "'": true,
        '"': true,
        ";": true,
    };

    function isPunctuation(char) {
        return !!punctuation[char];
    }

	function addContent() {
      view = 'read';

      if (!note) {
        language = document.getElementById("input-language").value;
      }

      const paragraphs = content.split("\n");

      for (let i = 0, j = 0; i < paragraphs.length; i++) {
        const elements = paragraphs[i].split(" ");
        const newArray = [];

        for (const el of elements) {
            if (el !== "") {
                newArray.push(el);
            }
        }

        if (newArray.length > 0) {
            newParagraphs[j] = newArray;
            j++;
        }
      }
	}

    function searchForWord(word) {
        const url = `${API_URL}/api/words/${language}/${word}`;
        document.getElementById("word-definition-error").innerHTML = "";
        linked = [];

        console.log("url", url)

        const response = fetch(url, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        }).then(data => {
            if (data.status === 200) {
                data.json().then(j => {
                    if (j) {
                        console.log(">>>>", j)
                        // const d = JSON.parse(j.data)
                        const d = j.data;
                        if (j.linked && j.linked.data) {
                            linked = JSON.parse(j.linked.data)
                            linkedWord = j.linked.word;
                        }

                        definition = d;
                        currentWord = j.word;
                    } else {
                        // Not found
                        definition = [];
                        currentWord = "";
                        linkedWord = "";
                        linked = [];
                        // document.getElementById("word-definition-error").innerHTML = `<b>${word}</b> not found`;
                    }
                })
            } else {
                definition = [];
                currentWord = "";
                linkedWord = "";
                linked = [];
                // document.getElementById("word-definition-error").innerHTML = `<b>${word}</b> not found`;
            }
        });
    }

    function searchWord() {
        const word = document.getElementById("search-input-word").value;

        searchForWord(word);
    }

    function contentClick(e) {
        let word = e.target.innerText;

        if (word.length > 0) {
            if (isPunctuation(word[0])) {
                word = word.substr(1);
            }

            if (isPunctuation(word[word.length - 1])) {
                word = word.substr(0, word.length - 1);
            }
        }

        word = word.trim();

        searchForWord(word);
    }

    onMount(async () => {
        if (note) {
            console.log("NOTE adding content, ", content);
            addContent();
            language = "it";
        }
    });


</script>

<Router>
    <div>
        <!-- <Route path="/signin" component={SignIn} /> -->
        <!-- <Route path="/signup" component={SignIn} /> -->
        <!-- <Route path="/read" component={Read} /> -->
    </div>
</Router>

<svelte:head>
  <title>polyreader</title>
</svelte:head>

    <!-- Nav -->
    <!-- <nav class="container-fluid">
        <ul>
          <li><a href="/" class="contrast"><strong>polyreader</strong></a></li>
        </ul>
        <ul>
            <li>
                {#if language !== ""}
                Language: <strong>{language}</strong>
                {/if}
            </li>
            <li><a href="/signin">Sign in</a></li>
            <li><a href="/signup">Sign up</a></li>
          </ul>
      </nav> -->
      <!-- ./ Nav -->

<div class="container-fluid">
      <div class="row row-example">
        <div class="col-sm-6 col-md-4 col-lg-3 col-xl-3">
          <div class="col-example">
            {#if view === 'input'}
            Enter text on the right and pick language the text is in
            <select id="input-language" name="language">
                <option name="lang-it" value="it">Italian (italiano)</option>
                <option name="lang-fr" value="fr">French (français)</option>
                <option name="lang-es" value="es">Spanish (español)</option>
                <option name="lang-de" value="de">German (deutsch)</option>
            </select>
        {:else}
        {#if !currentWord}
            <p>Click on a word to see its definition.</p>
        {/if}
        <p id="word-definition-error"></p>
        <h2 style="margin: 0;"><i>{currentWord}</i></h2>
        {#each definition as el}

            {#if (el.values.meanings && el.values.meanings.length > 0) || el.values.inflections && el.values.inflections.inf && el.values.inflections.type}
            <h4 style="margin: 0;">{el.section}</h4>
            {/if}

            {#if el.values.meanings && el.values.meanings.length > 0}
            <ol>
            {#each el.values.meanings as meaning}
            <li>{meaning.meaning}</li>
            {/each}
            </ol>
            {/if}

            {#if el.values.inflections && el.values.inflections.inf && el.values.inflections.type}
                {el.values.inflections.inf} ({el.values.inflections.type})
            {/if}
        {/each}

        {#if linked.length > 0}
            <h4 style="margin: 0;">Related: <i>{linkedWord}</i></h4>
            {#each linked as el}

            {#if (el.values.meanings && el.values.meanings.length > 0) || el.values.inflections && el.values.inflections.inf && el.values.inflections.type}
            <h4 style="margin: 0;">{el.section}</h4>
            {/if}

            {#if el.values.meanings && el.values.meanings.length > 0}
            <ol>
            {#each el.values.meanings as meaning}
            <li>{meaning.meaning}</li>
            {/each}
            </ol>
            {/if}

            {#if el.values.inflections && el.values.inflections.inf && el.values.inflections.type}
                {el.values.inflections.inf} ({el.values.inflections.type})
            {/if}
        {/each}
        {/if}

        {/if}

        {#if view === 'read'}
        <div>
            <div>
                <div>
                    <div>
                        <div>
                            <h4 style="margin: 0; margin-top: 20px;">Search</h4>
                            <div>
                                <input type="text" id="search-input-word" placeholder="Search for any words"/>
                            </div>
                            <div>
                                <button on:click={searchWord}>Search</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/if}


          </div>
        </div>
        <div class="col-sm-6 col-md-8 col-lg-9 col-xl-9">
          <div class="col-example">

            {#if view === 'input'}
            <div style="width: 100%;">
                <textarea style="width: 100%; height: 300px;" bind:value={content}/>
            </div>
            <div>
                <button on:click={addContent}>Add</button>
            </div>
            {:else if view === "read"}
            <div>
                {#each newParagraphs as p, i}
                <p>
                {#each p as el}
                <a href="#" class="contrast" style="cursor: pointer; padding-right: 4px;" on:click={contentClick}>{el.trim()}</a>
                {/each}
                </p>

                {/each}
            </div>
            {/if}

          </div>
        </div>
      </div><!-- ./ Grid Bootstrap -->
</div>
